<template>
	<div>
		<notifications group="global" />
		<nav class="navbar is-black">
			<div class="container">
				<div class="navbar-brand">
					<a class="navbar-item" href="/onesun">
						<img src="/one-sun-logo-white.png" alt="One Sun Logo" height="120px">
					</a>
					<a class="navbar-item phone" href="tel:18007120333">1-800-712-0333</a>
					<span class="navbar-burger burger" :class="{'is-active': menuOpen}" @click="toggleMenu">
						<span></span>
						<span></span>
						<span></span>
					</span>
				</div>
				<div id="navbarMenu" class="navbar-menu" :class="{'is-active': menuOpen}">
					<div class="navbar-end">
						<div class="tabs is-centered">
							<ul>
					<li class="is-active"><router-link :to="'/onesun'">Home</router-link></li>
					<li><router-link :to="'/onesun/apply'">Apply</router-link></li>
					<li><router-link :to="'/login'">Login</router-link></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</nav>
				<slot />
		<footer class="footer is-black">
			<div class="container">
				<div class="content has-text-centered">
					<p>
						One Sun © 2013-{{ year }}. All rights reserved. One Sun, LLC, 10801
						Starkey Rd, Suite 104-214, Seminole, FL 33777
					</p>
					<p>
						<img src="/new-seal-geo.png" alt="geotrust logo" height="120px">
					</p>
				</div>
			</div>
		</footer>
		</div>
</template>

<script>
export default {
	data() {
		return {
			menuOpen: false,
			year: new Date().getFullYear()
		}
	},
	methods: {
		toggleMenu() {
			this.menuOpen = !this.menuOpen
		}
	},
	created() {
		document.title = "One Sun"
	}
}
</script>